import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      title: formatMessage(messages.title),
      description: formatMessage(messages.description),
      btnCancel: formatMessage(messages.btnCancel),
      btnSubmit: formatMessage(messages.btnSubmit),
      overrideTimeLabel: formatMessage(messages.overrideTimeLabel),
    };

    return { translations };
  }, [formatMessage]);
  return result;
};
export default useTranslations;
